<template>
	<page>
		<module :title="id ? '编辑运费模板' : '新建运费模板'">
			<c-form ref="form">
				<c-form-item type="input" label="模板名称" name="name" required :readonly="template_readonly" :disabled="template_readonly"></c-form-item>
				<c-form-item v-model="freightMode" type="radio" label="计费方式" name="type" :options="freightModeOption" required :readonly="template_readonly" :disabled="template_readonly"></c-form-item>
				<c-form-item label="计费规则" name="rule" required>
					<p class="template-tips">除指定地区外，其余地区的运费采用<span>“默认运费”</span></p>
					<div class="template-detail">
						<div v-for="(item, i) in logisticsList" :key="i" class="item">
							<div class="check flex-center-cross">
								<c-checkbox :checked="item.id==0?true:item.active" :disabled="item.id==0" @change="logisticsCheck($event, item)">{{item.name}}</c-checkbox>
							</div>
							
							<div v-show="item.active">
								<table>
									<thead>
										<tr>
											<th style="width: 280px;">配送区域</th>
											<th v-if="freightMode == 2" style="width: 140px;">重量区间（【起：大于等于】【止：小于】）</th>
											<th>首{{freightMode == 1 ? '件' : '重'}}</th>
											<th>首费(元)</th>
											<th>续{{freightMode == 1 ? '件' : '重'}}</th>
											<th>续费(元)</th>
											<th>操作</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(area, j) in logisticsConfig[item.id]">
											<tr v-for="(row, k) in area.range" :key="`${area.id}_${k}`">
												<td v-if="k == 0" :rowspan="area.range.length + (freightMode == 1 ? 0 : 1)">{{area.name.join('，')}}</td>
												<td v-if="freightMode == 2">
													<div class="rang">
														<input v-model="row.start" type="text" :disabled="k == 0">
														<span>~</span>{{area.range[k+1] ? area.range[k+1].start : '—'}}
													</div>
												</td>
												<td><input v-model="row.firstCount" type="text"></td>
												<td><input v-model="row.firstSum" type="text"></td>
												<td><input v-model="row.continueCount" type="text"></td>
												<td><input v-model="row.continueSum" type="text"></td>
												<td>
													<div v-if="!area.default||k!=0">
														<a v-if="k == 0" @click="areaSelect(item, area)">编辑</a>
														<a @click="removeRangHandle(item.id, j, area, k)">删除</a>
													</div>
												</td>
											</tr>
											<tr v-if="freightMode == 2">
												<td colspan="6"><c-button color="gray" hollow @click="addRangHandle(area)">添加区间</c-button></td>
											</tr>
										</template>
									</tbody>
								</table>
								<div class="add">
									<a @click="areaSelect(item)">为指定区域设置运费</a>
								</div>
							</div>
						</div>
					</div>
				</c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit">提交保存</c-button>
			</template>
		</module>
		
		<c-dialog ref="area" title="指定配送区域" height="450" @resolve="areaSelectHandle">
			<div v-for="(area, i) in areaList" :key="i" class="area">
				<div class="area-name flex-center-cross">
					<div class="area-item flex-center" @click="areaFold(area)"><i class="tf" :class="{'tf-fold': !area.fold, 'tf-expand': area.fold}"></i>{{area.name}}</div>
				</div>
				<div v-show="!area.fold" class="area-list flex-wrap">
					<c-checkbox v-for="(item, j) in area.children" :key="j" :checked="currentArea[item.id]" :disabled="disabledArea[item.id]" @change="areaCheck($event, item)">{{item.name}}</c-checkbox>
				</div>
			</div>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'freight_template_edit',
		
		props: {
			id: String
		},
		
		data() {
			return {
        template_readonly:false,
				freightMode: 1,
				freightModeOption: [{
					name: '按件计费',
					value: 1
				}, {
					name: '按重计费',
					value: 2
				}],
				logisticsList: [],
				logisticsConfig: {},
				areaList: [],
				currentArea: {},
				disabledArea: {}
			}
		},
		
		watch: {
			id() {
				this.getDetail();
			}
		},
		
		mounted() {
			if (this.id) {
				this.getDetail();
			} else {
				this.getLogistics();
			}
		},
		
		methods: {
			getLogistics() {
				this.request({
					url: '/logistics_company/all_list',
					success: data => {
						this.logisticsList = data;
			            this.logisticsCheck(true, data[0]);
			          }
				});
			},
			
			getDetail() {
				this.request({
					url: '/freight_template/detail',
					data: {
						  id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set({
							name: data.name,
							type: data.type
						});
            this.logisticsList = [];
            this.logisticsConfig = {};
            this.areaList = [];
            this.currentArea = {};
            this.disabledArea = {};
            if (data.is_default == 2){
              this.template_readonly = true;
            }else {
              this.template_readonly = false;
            }
						data.template_detail.forEach(item => {
							var log = data.logistics_detail.find(log => {
								return log.id == item.logistics_company_id;
							});
							log && (log.active = true);
							
							if (!this.logisticsConfig[item.logistics_company_id]) {
								this.$set(this.logisticsConfig, item.logistics_company_id, []);
							}
							
							var area = this.logisticsConfig[item.logistics_company_id].find(area => {
								return area.id.join(',') == item.range;
							});
							
							if (!area) {
								area = {
									default: item.range == '0',
									id: item.range.split(','),
									name: item.range_names.split(','),
									range: []
								};
								this.logisticsConfig[item.logistics_company_id].push(area);
							}
							
							area.range.push({
								start: item.start_interval.toString(),
								firstCount: item.first_count.toString(),
								firstSum: item.first_money.toString(),
								continueCount: item.continue_count.toString(),
								continueSum: item.continue_money.toString()
							});
						});
						this.logisticsList = data.logistics_detail;
            this.logisticsCheck(true, data.logistics_detail[0]);
          }
				});
			},
			
			logisticsCheck(state, item) {
				this.$set(item, 'active', state);
				
				if (state && !this.logisticsConfig[item.id]) {
					this.$set(this.logisticsConfig, item.id, []);
					
					var area = {
						default: true,
						id: [0],
						name: ['默认运费'],
						range: []
					};
					this.logisticsConfig[item.id].push(area);
					
					this.addRangHandle(area);
				}
			},
			
			areaSelect(item, area) {
				this._logistics = item;
				this._area = area;
				
				if (!this.areaList.length) {
					this.request({
						url: '/address_library/region_first',
						data: {
							parent_id: 0
						},
						success: data => {
							this.areaList = data;
						}
					});
				}
				
				this.currentArea = {};
				this.disabledArea = {};
				this.logisticsConfig[this._logistics.id].forEach(item => {
					if (item.default) return;
					if (item == area) {
						item.id.forEach(id => {
							this.currentArea[id] = true;
						});
					} else {
						item.id.forEach(id => {
							this.disabledArea[id] = true;
						});
					}
				});
				
				this.$refs.area.open();
			},
			
			areaSelectHandle(stop) {
				var id = [], name = [];
				this.areaList.forEach(area => {
					area.children.forEach(item => {
						if (this.currentArea[item.id]) {
							id.push(item.id);
							name.push(item.name);
						}
					})
				});
				
				if (!id.length) {
					stop();
					this.$message({
						text: '请选择要指定的区域'
					});
					return;
				}
				
				if (this._area) {
					this._area.id = id;
					this._area.name = name;
				} else {
					var area = {
						id,
						name,
						range: []
					};
					this.logisticsConfig[this._logistics.id].push(area);
					
					this.addRangHandle(area);
				}
			},
			
			addRangHandle(item) {
				item.range.push({
					start: item.range.length ? item.range[item.range.length - 1].start : '0',
					firstCount: '',
					firstSum: '',
					continueCount: '',
					continueSum: ''
				});
			},
			
			removeRangHandle(logId, areaIndex, area, rangeIndex) {
				if (area.range.length > 1) {
					area.range.splice(rangeIndex, 1);
					
					if (rangeIndex == 0) {
						area.range[0].start = 0;
					}
				} else {
					this.logisticsConfig[logId].splice(areaIndex, 1);
				}
			},
			
			areaFold(item) {
				this.$set(item, 'fold', !item.fold);
			},
			
			areaCheck(state, item) {
				this.$set(this.currentArea, item.id, state);
			},
			
			submit() {
				var errorMessage = '', dataList = [];
				this.logisticsList.forEach(item => {
					if (item.active) {
						this.logisticsConfig[item.id].forEach(area => {
							area.range.forEach((range, index) => {
								if (!range.start || !range.firstCount || !range.firstSum || !range.continueCount || !range.continueSum) {
									!errorMessage && (errorMessage = `请完善物流公司【${item.name}】的计费规则`);
									return;
								}
								
								dataList.push({
									logistics_company_id: item.id,
									range: area.id.join(','),
									range_names: area.name.join(','),
									start_interval: range.start+'',
									end_interval: (index == area.range.length - 1 ? '-' : area.range[index + 1].start)+'',
									first_count: range.firstCount+'',
									first_money: range.firstSum+'',
									continue_count: range.continueCount+'',
									continue_money: range.continueSum+''
								});
							});
						});
					}
				});
				
				if (!errorMessage && !dataList.length) {
					errorMessage = '请配置计费规则';
				}
				
				this.$refs.form.submit({
					url: this.id ? '/freight_template/edit' : '/freight_template/add',
					
					rule: {
						name: '请填写运费模板名称',
						rule: [{
							type: 'function',
							fun: value => {
								errorMessage && this.$message({
									text: errorMessage
								});
								return !errorMessage;
							},
							word: false
						}]
					},
					
					dataFormatter: data => {
						data.id = this.id;
						data.detail_list = dataList;
						return data;
					},
					
					success: (data, param) => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('freightTemplate.update', this.id ? undefined : 1);
						this.$bus.$emit('productEdit.updateFreightTmpl');
						this.redirectTo('/freight_template');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.template {
		&-tips {
			line-height: 38px;
			font-size: 13px;
			color: #999;
			
			span {
				color: #f55;
			}
		}
		
		&-detail {
			position: relative;
			width: 1000px;
			padding: 10px 20px 0;
			overflow: hidden;
			background: #F9F8FB;
			
			.item {
				margin-bottom: 10px;
				
				.check {
					height: 40px;
				}
				
				.add {
					padding: 0 12px;
					line-height: 40px;
					background: #F4F4F4;
					
					a {
						font-size: 13px;
						color: #0030FF;
					}
				}
			}
			
			table {
				width: 100%;
			
				thead {
					background: #F9F9F9;
				}
				tbody {
					background: #fff;
				}
				th, td {
					width: 100px;
					line-height: 20px;
					border: 1px solid #ddd;
					color: #444;
					font-size: 12px;
					text-align: left;
				}
				
				th {
					height: 40px;
					padding: 0 10px;
				}
				
				td {
					padding: 10px;
						
					input {
						box-sizing: border-box;
						width: 100%;
						height: 24px;
						border: 1px solid #ddd;
						padding: 0 5px;
					}
					
					.rang {
						input {
							width: 60px;
							
							&:disabled {
								background: #efefef;
							}
						}
						
						span {
							margin: 0 10px;
						}
					}
					
					a {
						margin-right: 8px;
						font-size: 13px;
						color: #EA0101;
						
						&:nth-last-child(2) {
							color: #0030FF;
						}
					}
				}
			}
		}
	}
	
	.area {
		margin: 25px 30px;
		
		&-name {
			height: 30px;
		}
		
		&-item {
			font-size: 13px;
			font-weight: bold;
			cursor: pointer;
			
			.tf {
				margin-right: 5px;
			}
		}
		
		&-list {
			margin-left: 10px;
			
			.c-checkbox {
				margin-left: 14px;
				margin-top: 10px;
			}
		}
	}
</style>